import React from "react"
import moment from "moment"

export default function ModalShowAccessData({ onClose, data }) {

    return (
        <div className="z-[99] fixed flex top-0 right-0 w-full h-full justify-center items-center bg-[#0000008f]">
            {/* <HashLoader loading={loading} style={{ display: 'flex', justifyContent: 'center' }} color="#FF9768" /> */}
            <div className="w-[600px] bg-white rounded-md">
                <div className="flex justify-end mt-[10px] mr-[10px]">
                    <img className="w-7 h-7 cursor-pointer" alt="close-modal" onClick={() => { onClose() }} src={require('../../../asset/icon/close-icon.svg').default}></img>
                </div>
                <div className="-mt-5 p-7">
                    <div className='w-full text-2xl font-bold text-center'>
                        เจ้าหน้าที่กำลังเข้าถึงข้อมูลของท่าน
                    </div>
                    <div className='text-center text-base font-bold'>
                        <div className="text-amber-900">วันเวลาที่อนุญาต {data['accept_date']['time']} {moment(data["accept_date"]["date"]).add(543, "years").format("D MMMM YYYY")} </div>
               
                        <div>โดย {data['doctor']['pname'] + data['doctor']['fname'] + ' ' + data['doctor']['lname']}</div>
                        <div>{data['doctor']['hospital']['hospital_name']}</div>
                    </div>


                    <div style={{ display: 'flex', justifyContent: 'center', gridGap: 20 }} className="mt-4">
                        <button
                            onClick={() => {
                                onClose()
                            }}
                            className="px-5 py-2 text-white bg-blue-500 rounded-md">
                            ปิด
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}